module.exports = __webpack_public_path__ + "static/media/project_img_004.819aa6df.jpg";